import React from "react";

import { Type, Flex } from "discover.medical.react-component-library";
import useCTA, { CTA_TRIGGER_ACTION } from "../../util/useCTA";
import {
  CardContent,
  Image,
  IconImage,
  SmallIconImage,
  CardContainer,
  NavButton,
} from "./_.styled";

import { Link } from "react-router-dom";

const FeatureCard = ({
  buttonText,
  heading,
  children,
  landscapeSrc,
  portraitSrc,
  iconSrc,
  route,
  isGated,
}) => {
  const showImage = landscapeSrc || portraitSrc;
  const { hasCTA } = useCTA();

  const handleClick = (e) => {
    if (isGated) {
      hasCTA(e, CTA_TRIGGER_ACTION.FEATURE_CARD_CLICK);
    }
  };

  return (
    <CardContainer
      display="flex"
      borderColor="gray400"
      borderStyle="solid"
      borderWidth="1px"
      marginBottom="md"
    >
      <CardContent padding="md">
        <Flex
          container
          marginBottom="sm"
          align={{ item: "center" }}
          justify={{ content: "space-between" }}
        >
          <Type element="h2" fontFamily="secondary">
            {heading}
          </Type>
          {iconSrc && (
            <SmallIconImage
              data-testid="feature-card-small-icon"
              container
              iconSrc={iconSrc}
            />
          )}
        </Flex>
        {children}
        {buttonText && (
          <NavButton
            kind="outlined"
            variant="primary"
            forwardedAs={Link}
            to={route}
            onClick={handleClick}
          >
            {buttonText}
          </NavButton>
        )}
      </CardContent>
      {showImage && (
        <Image
          data-testid="feature-card-image"
          container
          landscapeSrc={landscapeSrc}
          portraitSrc={portraitSrc}
        />
      )}
      {iconSrc && (
        <IconImage
          data-testid="feature-card-icon"
          container
          iconSrc={iconSrc}
        />
      )}
    </CardContainer>
  );
};

export default FeatureCard;
